import { useCallback, useEffect, useRef } from 'react';

const DEFAULT_TIMEOUT_MS = 30_000;

export const useSensitiveDataTimer = (
  onClear: () => void,
  timeoutMs = DEFAULT_TIMEOUT_MS
) => {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clear = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    onClear();
  }, [onClear]);

  const start = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(clear, timeoutMs);
  }, [clear, timeoutMs]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return { start, clear };
};
